<script>
    import {_} from '../lib/i18n';
    export let show = false;

    export let paidTill;

    function closeModal() {
        show = false;
    }

    export let showNextModal = false;
    function toggleNextModal() {
        show = false;
        showNextModal = true;
    }
</script>

<section class={`modal ${show ? '' : 'hide'}`}>
    <div class="modal__fade"></div>
    <div class="modal-body modal-body_subscription-cancel">
        <div on:click={closeModal} class="modal-body__close-icon" on:click={closeModal}>
            <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.06665 7.4668L15.5333 14.9335" stroke="#C6C5D2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M15.5333 7.4668L8.06666 14.9335" stroke="#C6C5D2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </div>
        <div class="modal-body__header modal-body__header_кув">
            <div class="modal-body__header-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <ellipse cx="12.0007" cy="16.6677" rx="0.933333" ry="0.933333" fill="#C93329" />
                    <path d="M12.001 10.1348L12.001 13.8681" stroke="#C93329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M4.1142 17.5066L10.2115 5.31208C10.9485 3.83799 13.0521 3.83798 13.7892 5.31208L19.8864 17.5066C20.5513 18.8364 19.5844 20.401 18.0976 20.401H5.90306C4.4163 20.401 3.4493 18.8364 4.1142 17.5066Z" stroke="#C93329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </div>
            <h4 class="modal-body__header-title">
                {$_('cancelSubscriptionModal1.title')}
            </h4>
        </div>
        <div class="modal-body__content-wrapper">
            <p class="modal-body__content-text">
                {@html $_('cancelSubscriptionModal1.title', {
                    values: { paidTill }
                })}
            </p>
            <p class="modal-body__content-text">{$_('cancelSubscriptionModal1.keepMonitoringQuestion')}</p>
        </div>
        <div class="modal-body__controls-wrapper">
            <button class="button button_shadow modal-body__btn-main" on:click={closeModal}>
                {$_('cancelSubscriptionModal1.yes')}
            </button>
            <button class="button button_textual modal-body__btn-secondary" on:click={toggleNextModal}>
                {$_('cancelSubscriptionModal1.no')}
            </button>
        </div>
    </div>
</section>

<style>
    .hide {
        display: none;
    }
    .modal-body__header-title {
        color: #C93329;
    }
    .modal-body__header-icon {
        background-color: #F2D2C0;
    }
</style>